export const APP_NAME_COLOR = '#5C974E';
export const DELETE_COLOR = '#FA4770';
export const ACTIVE_CELL_COLOR = '#E4EFFE';
export const ACTIVE_LOOP_COLOR = '#E8F9F1';
export const ACTIVE_CELL_COLOR_IN_LOOP = '#ABEACD';
export const ACTIVE_LOOP_HEADER_COLOR = '#faffcf';
